<template>
  <div class="animated fadeIn container-fluid" v-if="project_detail">
    <b-row>
      <b-col md="8">
        <h2>{{ $t("menu." + i18n_key) }} {{ $t("n.cropping_season") }}</h2>
      </b-col>
      <b-col md="4">
        <SearchTool
          :list_data="project_detail[cropperiod_list_key]"
          :search_key="['name', 'description', 'note']"
          :search_tooltip="''"
          @search-result="search_result = $event"
        ></SearchTool>
      </b-col>
      <b-col md="12">
        <div class="block-text">
          <router-link
            class="btn btn-info btn-upload"
            :to="{ name: 'Cropperiod Management', query: { list: query_list } }"
          >
            <i class="icon-settings block-text"></i
            >{{ $t("menu.cropping_season_management") }} list (
            {{ $t("menu." + i18n_key) }} )
          </router-link>
        </div>
      </b-col>
    </b-row>

    <div class="">
      <b-card>
        <div v-if="search_result.length > 0">
          <b-row>
            <b-col md="4">
              <b-form-group label-cols-sm="5" label="每頁顯示數量" class="mb-0">
                <b-form-select
                  v-model="perPage"
                  :options="pageOptions"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="list-table-result scroll-style-gray overflow-x">
            <b-table
              hover
              small
              responsive="xl"
              :fields="table_fields"
              :items="table_items"
              :current-page="currentPage"
              :per-page="perPage"
            >
              <!-- A virtual column -->

              <template #cell(status)="row">
                <b-badge
                  :variant="
                    $tools.style.variantStatusButton(
                      'cropperiod',
                      row.item.status,
                      false
                    )
                  "
                  >{{ $t("status.cropperiod." + row.item.status) }}</b-badge
                >
              </template>

              <template #cell(details)="row">
                <b-button
                  size="sm"
                  @click="row.toggleDetails"
                  class="mr-2 btn-warning"
                >
                  {{ row.detailsShowing ? "Hide" : "Show" }}
                </b-button>
              </template>
              <template #row-details="row">
                <b-row>
                  <b-col md="1"></b-col>
                  <b-col md="3">
                    <div
                      class="proj-img cover-bg"
                      alt="project photo"
                      :style="
                        $tools.style.imgCover(
                          $config.checkURL('cropperiod', row.item.pic)
                        )
                      "
                    />
                  </b-col>
                  <b-col md="8">
                    <div>
                      <i class="icon-menu block-text"></i>
                      <div class="block-text">
                        {{ $t("menu.description") }}:
                      </div>
                      <div class="block-text">{{ row.item.description }}</div>
                    </div>
                    <div>
                      <i class="cui-dashboard block-text"></i>
                      <div class="block-text">{{ $t("n.field") }}:</div>
                      <div class="block-text">{{ row.item.farm_field }}</div>
                    </div>
                    <br />
                    <b-alert variant="secondary" show
                      >Note：{{ row.item.note }}</b-alert
                    >

                    <div class="text-center">
                      <div class="block-text">
                        <b-button
                          class="px-4 btn-upload btn-red"
                          variant="danger"
                          @click="change_status(row.item, 'farming')"
                        >
                          將狀態改回 【 {{ $t("status.cropperiod.farming") }} 】
                        </b-button>
                      </div>
                      <div class="block-text">
                        <router-link
                          class="btn btn-info btn-upload"
                          :to="{
                            name: 'Cropperiod Management',
                            query: { edit: row.item.id, list: query_list },
                          }"
                        >
                          <i class="icon-settings block-text"></i
                          >{{ $t("menu.editting") }}
                        </router-link>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <br />
              </template>
            </b-table>

            <!-- 分頁 -->
            <b-row v-if="perPage">
              <b-col md="6" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="table_items.length"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-row>
          </div>
        </div>
        <div v-else>
          <NoData></NoData>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NoData from "@/views/components/NoData";
import SearchTool from "@/views/components/SearchTool";

export default {
  components: {
    NoData,
    SearchTool,
  },
  data() {
    return {
      uploading: false,
      search_result: [],
      cropperiod_list_key: "cropperiods",
      i18n_key: "unfinished",
      query_list: "",

      // table
      table_fields: [
        { key: "idx", sortable: true },
        { key: "id", sortable: true },
        { key: "name", sortable: true },
        { key: "crop_info_id", sortable: true },
        { key: "start_date", sortable: true },
        { key: "end_date", sortable: true },
        { key: "status", sortable: true },
        { key: "details", sortable: false },
      ],
      table_items: [],
      currentPage: 1,
      perPage: 50,
      pageOptions: [
        { value: 10, text: 10 },
        { value: 20, text: 20 },
        { vlaue: 50, text: 50 },
        { value: 100, text: 100 },
        { value: undefined, text: "all" },
      ],
    };
  },
  // 在 router 改變、vue 頁面更新後處理：頁面網址數值變更自動執行
  beforeRouteUpdate(to, from, next) {
    // 根據網址判斷要編輯的是哪個狀態的期作清單
    this.checkEditMode(to.params);
    this.getProject(to, from, next);
  },
  mounted() {
    // 根據網址判斷要編輯的是哪個狀態的期作清單
    this.checkEditMode(this.$route.params);
    this.getProject();
  },
  computed: {
    ...mapState({
      user_admin: (state) => state.user.is_admin,
      project_detail: (state) => state.project.project_detail,
      cropperiod_status_List: (state) => state.cropperiod.list_status,
    }),

    projID() {
      return this.$route.params.projectID;
    },
  },
  watch: {
    search_result(val, oldVal) {
      if (val) {
        this.arrangeTableData();
      }
    },
  },
  methods: {
    checkEditMode(params) {
      // 根據網址判斷要編輯的是哪個狀態的期作清單
      if (params.listType == "done") {
        this.cropperiod_list_key = "done_cropperiods";
        this.i18n_key = "finished";
        this.query_list = "done";
      } else if (params.listType == "abandon") {
        this.cropperiod_list_key = "abandon_cropperiods";
        this.i18n_key = "abandoned";
        this.query_list = "abandon";
      } else {
        this.cropperiod_list_key = "cropperiods";
        this.i18n_key = "unfinished";
        this.query_list = "";
      }
    },

    // 取得專案資料
    getProject(to = undefined, from = undefined, next = undefined) {
      let _projID = next ? to.params.projectID : this.projID;

      if (_projID) {
        this.$store
          .dispatch("project/getProjectDetail", _projID)
          .then((res) => {
            if (this.user_admin) {
              if (next) next();
            } else {
              this.$router.push({
                name: "Page403",
              }); // 導向 403
            }
          })
          .catch((err) => {});
      }
    },

    change_status(cropInfo, status = "farming") {
      this.uploading = true;
      let _note = cropInfo.note ? cropInfo.note : "";
      let _data = {
        status: status,
        end_date: null, // 因為 done 和 abandon 走另一個 API，故改變狀態就把 end_date 清掉
        note:
          _note +
          " [changed to " +
          status +
          ": " +
          this.$tools.date.getDateNow("UTC", "YYYY-MM-DD HH:mm:ss") +
          "(UTC)]", // note 加上改狀態的時間
      };

      let _url = this.$config.getAPI_URL("Update_Cropperiod", {
        cropperiodID: cropInfo.id,
      });

      const options = {
        method: "PUT",
        url: _url,
        data: _data,
      };
      this.$http(options)
        .then((res) => {
          this.getProject();
          this.$toastr.s(this.$t("other.update_succeeded"), "");
        })
        .catch((err) => {
          this.uploading = false;
          this.$toastr.e(
            this.$t("other.update_failed") +
              "<br>" +
              err.data.status +
              "<br>" +
              err.data.message,
            ""
          );
        });

      // 送出使用者操作紀錄 --------------------
      let _OPLog = {
        user_id: this.$store.state.user.id,
        type: "write",
        detail: {
          page: "cropperiod",
          action: "reset status",
          querySettings: {
            "project ID": this.projID,
            "project name": this.project_detail.name,
            "cropperiod ID": cropInfo.id,
            "cropperiod name": cropInfo.name,
            "cropperiod status": cropInfo.status + " => " + status,
            "user role": this.project_detail.role,
            "project status": this.project_detail.status,
            "service level": this.project_detail.service_level,
          },
        },
      };
      this.$store
        .dispatch("user/createLog", _OPLog)
        .then((res) => {})
        .catch((err) => {});
      // 送出使用者操作紀錄 --------------------
    },

    arrangeTableData() {
      let _items = [];
      this.search_result.forEach((_data, _idx) => {
        let _new_data = this.$tools.data.deepCopy_object(_data); // 複製一份

        _new_data["idx"] = _idx + 1;

        _items.push(_new_data);
      });
      this.table_items = _items;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
